// import {ReducerTypes} from "./constant";
export const Exitreasons = (type, data) => ({
  type,
  payload: data,
});
